export { ClientInfoCard } from "./components/ClientInfoCard";
export { useClientInfo } from "./hooks/useClientInfo";
export type { ClientInfo, ClientInfoState } from "./types";